import * as React from "react";
import type { SVGProps } from "react";
const SvgHelpSquareContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 16.8v.042M9.601 9.045c0-1.35 1.075-2.445 2.4-2.445 1.326 0 2.4 1.095 2.4 2.445s-1.075 2.446-2.4 2.446L12 13.12M21.6 6v12a3.6 3.6 0 0 1-3.6 3.6H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6"
    />
  </svg>
);
export default SvgHelpSquareContained;
